import { Privileges } from '@cube3/state/src/redux/components/Hooks/privileges';
import { useCurrentProject } from '@cube3/state/src/redux/components/Hooks/useCurrentProject';
import { useWorkspacePermissions } from '@cube3/state/src/redux/components/Hooks/usePermission';
import { useMemo } from 'react';
import { useVisitingPathParams } from '../../hooks/useVisitingPathParams';
const privileges = ['LIBRARY_WRITE', 'PROJECT_WRITE'] as Privileges[];

export const useDragPermissions = (strict = false) => {
  const [canWriteLibrary] = useWorkspacePermissions(privileges);
  const { isProjectArchived, isProjectRoleReadOnly } = useCurrentProject();

  const {
    libraryId,
    projectId,
    inProjectsOverview,
    inFavoritesOverview,
    inBinOverview
  } = useVisitingPathParams();

  const allowDrag = !!libraryId || !!projectId;
  const inDroppableView = inFavoritesOverview || inBinOverview;
  const allowDrop =
    (strict
      ? allowDrag || inProjectsOverview
      : allowDrag || inDroppableView || inProjectsOverview) &&
    canWriteLibrary &&
    !isProjectArchived &&
    !isProjectRoleReadOnly;

  const disabledReason = !canWriteLibrary
    ? 'This account has no permission to move files'
    : isProjectRoleReadOnly
    ? 'Moving files not allowed because you are not a member of this project'
    : isProjectArchived
    ? 'Moving files not allowed because this project is archived'
    : '';

  return useMemo(
    () => ({ allowDrag, allowDrop, disabledReason }),
    [allowDrag, allowDrop, disabledReason]
  );
};
